import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Bolet que neix semienterrat en forma globulosa, de 5 a 10 cm de diàmetre. Al sortir a l’exterior s’obre en forma d’estrella amb 3 ó 4 lòbuls, on l’interior és buit i llis de color blavós o liliaci. Amb l’edat la superfície interna pot enfosquir-se i passar a color terrós castany. Les espores són el·líptiques, de 15-20 x 8-9 micres.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      